// extracted by mini-css-extract-plugin
module.exports = {"root":"CardDate_root__87tZu"};